<template>
  <div class="sharke" @click="hideEvent" style="display:block"><img :src="share.url" alt=""></div>
</template>
<script>
export default {
  props: {
    share: Object
  },
  methods: {
    hideEvent() {
      var that = this;
      that.$dispatch('hideEvent');
      that.$dispatch('maskFlagEvent',false);
    }
  }
}
</script>


// WEBPACK FOOTER //
// ShareMask.vue?509aade4